import { Emitter } from "pixi-particles";
import * as Constants from "../Data/Constants";

export enum ConfettiColourSuffixes {
    RED = "-red",
    ORANGE = "-orange",
    YELLOW = "-yellow",
    GREEN = "-green",
    BLUE = "-blue",
    BLACK = "-black",
    WHITE = "",
}

export class BalloonConfetti extends PIXI.Container {
    private readonly _particles: Emitter;

    constructor(pColours: ConfettiColourSuffixes[]) {
        super();
        const shapes: string[] = [ "rect", "circle", "tri" ];
        const particles: any[] = new Array<any>();
        const sheet: PIXI.loaders.Resource = PIXI.loader.resources[Constants.SPRITESHEET_UI];
        const colours = pColours;
        for (let i = 0; i < colours.length; ++i) {
            for (let j = 0; j < shapes.length; ++j) {
                particles.push(sheet.textures!["particle-confetti-" + shapes[j] + colours[i]]);
            }
        }

        this._particles = new Emitter(
            this,
            particles,
            {
                alpha: {
                    list: [
                        { value: 0.1, time: 0 },
                        { value: 0.8, time: 0.1 },
                        { value: 0.8, time: 0.8 },
                        { value: 0.1, time: 1 },
                    ],
                    isStepped: false,
                },
                speed: {
                    list: [
                        { value: 400, time: 0 },
                    ],
                    isStepped: false,
                    minimumSpeedMultiplier: 0.1,
                },
                acceleration: new PIXI.Point(0, 500),
                // startRotation: { min: 180, max: 360 },
                startRotation: { min: 135, max: 405 },
                rotationSpeed: { min: 0, max: 0 },
                lifetime: { min: 0.75, max: 1.0 },
                frequency: 0.01,
                spawnChance: 1,
                particlesPerWave: 30,
                emitterLifetime: 0.75,
                maxParticles: 50,
                pos: { x: 0, y: 0 },
                addAtBack: false,
                spawnType: "circle",
                spawnCircle: { x: 0, y: 0, r: 30 },
            },
        );
        this._particles.emit = false;
    }

    public play(): void {
        this._particles.autoUpdate = true;
        this._particles.emit = true;
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        this._particles.emit = false;
        this._particles.destroy();
        super.destroy(pOptions);
    }
}
